module.exports = __webpack_public_path__ + "public/img/uxb_order_icon_vip.7c40190b.png";